import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";


const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const tokenWithoutQuotes = token ? token.replace(/"/g, "") : "";

  return {
    Authorization: tokenWithoutQuotes ? `Bearer ${tokenWithoutQuotes}` : "",
  };
};

const unwrapData = (response) => response.data;

export const getNHICSettings = (type) =>
  axios
    .get(`${API_BASE_URL}/nhic/settings`, {
      params: type ? { type } : undefined,
      headers: getAuthHeaders(),
    })
    .then(unwrapData);

export const saveNHICSettings = (input) =>
  axios
    .post(`${API_BASE_URL}/nhic/settings`, input, {
      headers: getAuthHeaders(),
    })
    .then(unwrapData);

export const getPatientHealthID = (documentId, dateOfBirth) =>
  axios
    .get(`${API_BASE_URL}/nhic/patient/${encodeURIComponent(documentId)}/health-id`, {
      params: { date_of_birth: dateOfBirth },
      headers: getAuthHeaders(),
    })
    .then(unwrapData);

export const getPractitionerHealthID = (practitionerId) =>
  axios
    .get(
      `${API_BASE_URL}/nhic/practitioner/${encodeURIComponent(
        practitionerId,
      )}/health-id`,
      {
        headers: getAuthHeaders(),
      },
    )
    .then(unwrapData);
